import * as angular from 'angular';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { RetailerService } from '../../../api/retailer.service';
import { IPrinter, TestPrintStatusEnum } from '../../models/models';
import { PrintersService } from '../../services/printers.service';

class PrinterListComponent {
    public static $inject = [
        '$translate',
        'notificationService',
        'printersService',
        'popupService',
        'retailerService',
    ];

    public waiting: boolean;
    public printerList: IPrinter[];
    public statuses = TestPrintStatusEnum;

    constructor(
        private $translate: angular.translate.ITranslateService,
        private notificationService: NotificationService,
        private printersService: PrintersService,
        private popupService: PopupService,
        private retailerService: RetailerService
    ) {
    }

    public async $onInit() {
        await this.loadData();
    }

    public getLogoUrl(iconId: number): string {
        return this.retailerService.getStoreLogoUrl(iconId, 48, 48);
    }

    public async deletePrinterConfirm(printer: IPrinter) {
        try {
            const result = await this.popupService.confirm({
                title: this.$translate.instant('delete_printer_title'),
                content: `<div style="word-break: break-all; padding-top: 8px;">${this.$translate.instant(
                    'delete_printer_content'
                )}</div>`,
                cancelClass: 'btn btn-with-icon btn-in-popup-footer',
                okClass:
                    'btn btn-with-icon btn-with-icon--before-delete btn-danger flexVerticalAlignParent',
                classPopup: 'popup--redesign modal360',
                cancelTxt: this.$translate.instant('cancel'),
                okTxt: this.$translate.instant('delete'),
                hasIcon: true,
                thinTitle: true
            });

            if (result) {
                this.deletePrinterRequest(printer);
            }
        } catch (e) {
            return;
        }
    }

    public async testPrinter(printer: IPrinter) {
        printer.IsTestPrinting = true;
        printer.Status = null;
        try {
            const response = await this.printersService.testPrint(printer.PrinterID, printer.PlaceDetails.PlaceID);
            printer.Status = response.Status;
            printer.IsTestPrinting = false;
        } catch (e) {
            printer.IsTestPrinting = false;
            return;
        }
    }

    private async loadData() {
        if (this.waiting) {
            return;
        }

        this.waiting = true;
        this.notificationService.showWaitingMessage();

        try {
            this.printerList = await this.printersService.getPrinterList();
            this.waiting = false;
            this.notificationService.clearAll();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
            this.waiting = false;
        }
    }

    private async deletePrinterRequest(printer: IPrinter) {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            await this.printersService.deletePrinter(printer.PrinterID, printer.PlaceDetails.PlaceID);
            this.waiting = false;
            this.notificationService.showSuccessMessage();
            this.printerList = this.printerList.filter((item) => item.PrinterID !== printer.PrinterID);
        } catch (error) {
            this.notificationService.showErrorMessage(error);
            this.waiting = false;
        }
    }
}

angular.module('naut').component('printerListComponent', {
    template: require('./printer-list.component.html'),
    controller: PrinterListComponent,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/printers/components/printer-list/printer-list.component.ts